import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-dynamic',
    templateUrl: './modal-dynamic.component.html',
    styleUrls: [],
    standalone: false
})
export class ModalDynamicComponent {

}
